import stringify from 'json-stringify-pretty-compact';
import { captureException } from '@sentry/browser';
import base64Decoder from './base64Decoder';

/**
 * Handles any special formatting rules post decoding.
 */
export default function base64DecodePretty({ encodedData, lang }) {
  try {
    const decodedContent = base64Decoder(encodedData);

    switch (lang) {
      case 'json':
        return stringify(JSON.parse(decodedContent));
      default:
        return decodedContent;
    }
  } catch (e) {
    captureException(e);
    return '';
  }
}
